/**
 * Breadcrumbs.jsx
 * Created by Destin Frasier on 7/24/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { truncate, uniqueId } from 'lodash';
import { sluggify } from '../../helpers/stringHelper';

const propTypes = {
    path: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string
    })).isRequired,
    maxLengthTitle: PropTypes.number
};

const defaultProps = {
    maxLengthTitle: 100
};

const generateItem = (item, maxLengthTitle) => {
    const title = truncate(item.title, { length: maxLengthTitle });
    if (item.url) {
        return (
            <a
                href={item.url}
                id={`breadcrumb-item-${sluggify(title)}`}>
                {title}
            </a>
        );
    }
    return (<span>{title}</span>);
};

const Breadcrumbs = ({ path, maxLengthTitle }) => (
    <nav aria-label="Breadcrumbs">
        <ul className="rec-breadcrumb">
            {path.map((item) => (
                <React.Fragment key={`breadcrumb-${item.title}`}>
                    <li key={`${uniqueId(item.title)}`}>{generateItem(item, maxLengthTitle)}</li>
                    <div className="breadcrumb-separator" aria-hidden="true">/</div>
                </React.Fragment>
            ))}
        </ul>
    </nav>
);

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;

export default Breadcrumbs;
